<template>
  <div class="fccPublicacoesContasBancarias">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :actions="actions"
            addFilter
            :items="listarBancoPublicacao"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            fieldVisibility
            pdf
            csv
            xls
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          >
          </fccTable>
        </div>
      </div>
    </div>
    <fccModal
      centered
      size="xl"
      idModal="modalAddConta"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form
        autocomplete="off"
        @submit.prevent="inserir.idcontabancaria === 0 ? adicionandoCnpj() : editandoCnpj()"
      >
        <div class="etapas configuracoes">
          <div class="borderForm innerPage">
            <div class="row my-3">
              <div class="col-sm-3">
                <fccInput
                  extraClasses="inputLabel"
                  required
                  minlength="14"
                  v-model="inserir.cnpjbeneficiario"
                  v-mask="cnpjMask"
                  >CNPJ<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-9">
                <fccInput extraClasses="inputLabel" required v-model="inserir.nomebeneficiario"
                  >Beneficiario<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-3">
                <fccInput extraClasses="inputLabel" v-model="inserir.descricao"
                  >Descrição<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-9">
                <fccInput extraClasses="inputLabel" v-model="inserir.textoapresentacao"
                  >Texto Apresentação<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-6">
                <fccBancos
                  v-on:changesBanco="changeBancos"
                  :valorDeclarado="{ agencia: inserir.numerobanco, nomebanco: inserir.nomebanco }"
                  placeholder="Selecione o Banco"
                ></fccBancos>
                <input type="hidden" v-model="inserir.numerobanco" />
                <input type="hidden" v-model="inserir.nomebanco" />
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-3">
                <fccInput extraClasses="inputLabel" required v-model="inserir.agencia"
                  >Agência<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-3">
                <fccInput extraClasses="inputLabel" required v-model="inserir.digitoagencia"
                  >Digito<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-3">
                <fccInput extraClasses="inputLabel" required v-model="inserir.contabeneficiario"
                  >Conta<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-3">
                <fccInput
                  extraClasses="inputLabel"
                  required
                  v-model="inserir.digitocontabeneficiario"
                  >Digito<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-4">
                <fccInput extraClasses="inputLabel" v-model="inserir.carteira"
                  >Carteira<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-4">
                <fccInput extraClasses="inputLabel" v-model="inserir.numeroconvenio"
                  >Nº de Convênio<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-4">
                <fccInput extraClasses="inputLabel" v-model="inserir.numerocomercioeletronico"
                  >Nº Comércio eletrônico<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-12">
                <fccInput extraClasses="inputLabel" required v-model="inserir.localpagamento"
                  >Local de pagamento<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-3">
                <fccInput
                  extraClasses="inputLabel"
                  required
                  @change="buscandoCep"
                  v-mask="cepMask"
                  v-model="inserir.cep"
                  >CEP<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-6">
                <fccInput extraClasses="inputLabel" required v-model="inserir.logradouro"
                  >Endereço<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-3">
                <fccInput extraClasses="inputLabel" required v-model="inserir.numero"
                  >Número<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row my-12">
              <div class="col-sm-12">
                <fccInput extraClasses="inputLabel" v-model="inserir.complemento"
                  >Complemento<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-4">
                <fccInput extraClasses="inputLabel" required v-model="inserir.bairro"
                  >Bairro<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-5">
                <fccInput extraClasses="inputLabel" required v-model="inserir.cidade"
                  >Cidade<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-3">
                <fccInput extraClasses="inputLabel" required v-model="inserir.uf"
                  >UF<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row my-3 buttonSalvar">
              <div class="col-sm-12">
                <fccButton tipo="submit">{{ labelsSystem.salvar }}</fccButton>
              </div>
            </div>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import './../assets/sass/fccPublicacoes.scss'
import axios from 'axios'
import store from '@/store'
import fccBancos from '@/fccComponents/global/fccGestaoProjetos/fccBancos.vue'

export default {
  name: 'fccPublicacoesContasBancarias',
  data() {
    return {
      titlePage: 'Contas Bancárias',
      titlePDF: 'Lista de Contas Bancárias - Publicações',
      itemPorPage: '100',
      titleModal: '',
      sortBy: 'nomebeneficiario',
      listarBancoPublicacao: [],
      fields: [
        { key: 'cnpjbeneficiario', label: 'CNPJ', sortable: true, active: true },
        { key: 'nomebeneficiario', label: 'Nome Beneficiário', sortable: true, active: true },
        { key: 'nomebanco', label: 'Banco', sortable: true, active: true },
        { key: 'actions', label: '', active: true }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editaConta',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteConta',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      inserir: {}
    }
  },
  components: {
    fccBancos
  },
  methods: {
    listandoBancosPublicacao() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao + 'ContaBancaria/ListarContaBancaria',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listarBancoPublicacao = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    editandoCnpj() {
      this.changeContent(this.inserir)
      this.inserir.cnpjbeneficiario = this.removeAcento(this.inserir.cnpjbeneficiario)
      this.inserir.cep = this.removeAcento(this.inserir.cep)
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlPublicacao + 'ContaBancaria/AlterarContaBancaria',
          this.inserir,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoBancosPublicacao()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'modalAddConta')
          this.callToast(this.mensagensUpdate.editado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'modalAddConta')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    editaConta(action, item) {
      this.titleModal = 'Editar Conta Bancária'
      this.changeContent(item)
      this.$root.$emit('bv::show::modal', 'modalAddConta')
    },
    deleteConta(action, item) {
      this.callConfirm(this.mensagemExcluir, item.nomebeneficiario).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlPublicacao + 'ContaBancaria/ExcluirContaBancaria/' + item.idcontabancaria,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoBancosPublicacao()
              this.callToast(this.mensagensUpdate.excluido)
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    buscandoCep: async function () {
      this.carregaTexto(this.codeMensagem('C01'))
      var cep = await this.buscarEnderecoCep(this.inserir.cep)
      if (cep !== 'CEP NAO ENCONTRADO') {
        this.inserir.logradouro = cep.log_no
        this.inserir.bairro = cep.bai_no
        this.inserir.cidade = cep.loc_no
        this.inserir.uf = cep.ufe_sg
        this.carregaTexto()
      } else {
        this.inserir.logradouro = ''
        this.inserir.bairro = ''
        this.inserir.cidade = ''
        this.inserir.uf = ''
        this.callAlert('CEP não encontrado', '', 'error')
        this.carregaTexto()
      }
    },
    adicionandoCnpj() {
      this.inserir.cnpjbeneficiario = this.removeAcento(this.inserir.cnpjbeneficiario)
      this.inserir.cep = this.removeAcento(this.inserir.cep)
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlPublicacao + 'ContaBancaria/InserirContaBancaria',
          this.inserir,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoBancosPublicacao()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'modalAddConta')
          this.callToast(this.mensagensUpdate.adicionado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'modalAddConta')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    changeBancos(recebe) {
      this.inserir.numerobanco = recebe.agencia
      this.inserir.nomebanco = recebe.nomebanco
    },
    addField() {
      this.titleModal = 'Nova Conta Bancária'
      this.inserir = {
        idcontabancaria: 0,
        idpublicacao: 0,
        idpublicacaocontabancaria: 0,
        srcimg: '',
        url: '',
        cnpjbeneficiario: '',
        nomebeneficiario: '',
        descricao: '',
        textoapresentacao: '',
        numerobanco: '',
        agencia: '',
        digitoagencia: '',
        contabeneficiario: '',
        digitocontabeneficiario: '',
        carteira: '',
        numeroconvenio: '',
        numerocomercioeletronico: '',
        localpagamento: '',
        flgerararquivoremessa: '',
        flgerararqbaixa: '',
        cep: '',
        logradouro: '',
        bairro: '',
        cidade: '',
        uf: '',
        nomebanco: '',
        numero: '',
        complemento: ''
      }
      this.$root.$emit('bv::show::modal', 'modalAddConta')
    },
    changeContent(item) {
      this.inserir = {
        idcontabancaria: item.idcontabancaria,
        idpublicacao: 0,
        idpublicacaocontabancaria: 0,
        srcimg: '',
        url: '',
        cnpjbeneficiario: this.removeAcento(item.cnpjbeneficiario),
        nomebeneficiario: item.nomebeneficiario,
        descricao: item.descricao,
        textoapresentacao: item.textoapresentacao,
        numerobanco: item.numerobanco,
        agencia: item.agencia,
        digitoagencia: item.digitoagencia,
        contabeneficiario: item.contabeneficiario,
        digitocontabeneficiario: item.digitocontabeneficiario,
        carteira: item.carteira,
        numeroconvenio: item.numeroconvenio,
        numerocomercioeletronico: item.numerocomercioeletronico,
        localpagamento: item.localpagamento,
        flgerararquivoremessa: item.flgerararquivoremessa,
        flgerararqbaixa: item.flgerararqbaixa,
        cep: this.removeAcento(item.cep),
        logradouro: item.logradouro,
        bairro: item.logradouro,
        cidade: item.cidade,
        uf: item.uf,
        nomebanco: item.nomebanco,
        numero: item.numero,
        complemento: item.complemento
      }
    }
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.listandoBancosPublicacao()
  }
}
</script>
